/* eslint-disable @reatom/unit-naming-rule */

import { limitOrderRegistry } from '@root/entities/limit-order'
import { reatomLimitOrder } from '@root/entities/limit-order/atoms/reatom-limit-order'
import { LimitOrderId } from '@root/entities/limit-order/model/limit-order-id'

import { reatomSwapOrder } from './reatom-swap-order'
import { swapOrderRegistry } from './swap-order-registry'

import type { SwapOrderModel } from './reatom-swap-order'
import type { LimitOrderModel } from '@root/entities/limit-order/atoms/reatom-limit-order'
import type { PairModel } from '@root/entities/pair'
import type { TradeType } from '@root/entities/trade-type/model'
import type { TradeApi } from '@root/shared/api'

type Base =
  | {
      type: 'limit'
      order: LimitOrderModel
    }
  | {
      type: 'market'
      order: SwapOrderModel
    }

export const reatomOrder = ({
  dto,
  pair,
}: {
  dto: TradeApi.OrderDto
  pair: PairModel
}) => {
  const id = LimitOrderId(dto.id)

  const order = ((): Base => {
    if ('rollingStats' in dto) {
      return {
        type: 'market',
        order: swapOrderRegistry.getOrCreate(LimitOrderId(dto.id), () =>
          reatomSwapOrder({ dto, pair }),
        ),
      }
    }

    return {
      type: 'limit',
      order: limitOrderRegistry.getOrCreate(LimitOrderId(dto.id), () =>
        reatomLimitOrder({ dto, pair }),
      ),
    }
  })()

  const orderType = ((): TradeType.Type => {
    if (order.type === 'limit') {
      return order.order.type === 'buy' ? 'limit-buy' : 'limit-sell'
    }

    return order.order.type === 'buy' ? 'market-buy' : 'market-sell'
  })()

  return {
    ...order,
    id,
    orderType,
  }
}

export type OrderModel = ReturnType<typeof reatomOrder>
